/**
 * WebSite schema with SearchAction — enables Google's sitelinks search box.
 * Referenced by the homepage head. Static — safe to memoize.
 */

export const buildWebSiteSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': 'https://www.elevationelectricalfl.com/#website',
  url: 'https://www.elevationelectricalfl.com/',
  name: 'Elevation Electrical, LLC',
  description:
    'Licensed electrician serving Volusia, Seminole, Orange, and Lake-Sumter counties in Central Florida.',
  publisher: { '@id': 'https://www.elevationelectricalfl.com/#business' },
  inLanguage: 'en-US',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate:
        'https://www.elevationelectricalfl.com/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
});
